import React, { Component } from 'react';
import {Switch,Route} from 'react-router-dom';
import Detail from '../AppDetails/AppDetail'
import EditAppForm from '../AppDetails/EditApp';
import Notification from '../Notifications/Notification';
import History from '../Notifications/History';
import AppDetails from '../AppDetails/AppDetails';
import AddAppForm from '../AppDetails/AddApp';
import AddMember from '../Member/addMember';
import Publishers from '../publisher/Publishers';
import Navbar from '../layouts/Navbar'
import SideNav from '../layouts/SideNav'
import Dashboard from '../Dashboard/Dashboard';
import CalendarApp from '../CalendarApp/App'

class Admin extends Component{
    state={
        heading:'heading'
    }
    
    componentDidMount(){
      this.onChangeHeading("Dashboard")
    }

    onChangeHeading=(title)=>{
        this.setState({heading:title});
    }

    render(){
        const {match} = this.props;
        
        return(
            <div>
             <Navbar match={match} heading={this.state.heading} />
             <SideNav match={match} />
             <div className="container">
             <div className="row">
             <div className="col l12 s12 offset-l2">  
            <Switch>
            <Route exact path={`${match.url}/`}  component={Dashboard} />
            <Route  path={`${match.url}/dashboard`} component={Dashboard} />
            <Route  path={`${match.url}/AddApp`} component={AddAppForm} />
            <Route  path={`${match.url}/AppDetails`} component={AppDetails} />
            <Route  path={`${match.url}/AppDetail/:id/:pub`} component={Detail}/>
            <Route  path={`${match.url}/AddMember`} component={AddMember}/>
            <Route  path={`${match.url}/publishers`} component={Publishers}/>
            <Route  path={`${match.url}/EditApp/:id/:pub`}  component={EditAppForm}/>
            <Route exact path={`${match.url}/CreateNotification`} component={Notification}/>
            <Route exact path={`${match.url}/CreateNotification/:id`} component={Notification}/>
            <Route  path={`${match.url}/NotificationHistory`} component={History}/>
            <Route  path={`${match.url}/CalendarApp`} match={match} component={CalendarApp}/>
            </Switch>
            </div>
            </div>
            </div>
        </div>
        )
    }
}

export default Admin